/** Snooze presets, in minutes. */
export const SNOOZE_PRESETS = [15, 30, 60, 120, 240, 480, 1440] as const;
